import {StructuredDataContent} from 'rlink-repos/content';

export class ShopItem extends StructuredDataContent {
  static get contentIcon () {
    return 'shopping-cart';
  }

  static defaultData () {
    return {
      priority: 1.0,
      ratingReasons: [],
      showMoreInfoButton: true,
      showStatusBar: true,
    };
  }
  get backgroundPath () {
    return this.data.get('backgroundPath');
  }

  get slug () {
    return this.data.get('slug', `${this.title}${(this.subtitle) ? '-' + this.subtitle : ''}`.replace(/[^a-zA-Z0-9]+/g, '-').replace(/(^-|-$)/g, '').toLowerCase());
  }

  get squareBackgroundPath () {
    return this.data.get('squareBackgroundPath');
  }

  get modalBackgroundPath () {
    return this.data.get('modalBackgroundPath');
  }

  get vendor () {
    return this.data.get('vendor');
  }

  get identifier () {
    return this.data.get('identifier');
  }

  get purchaseIdentifier () {
    return this.data.get('purchaseIdentifier');
  }

  get viewsWhitelist () {
    return this.data.get('viewsWhitelist', []);
  }

  get title () {
    return this.data.get('title');
  }

  get subtitle () {
    return this.data.get('subtitle');
  }

  get modalTitle () {
    return this.data.get('modalTitle');
  }

  get purchaseModalWidth () {
    return this.data.get('purchaseModalWidth');
  }

  get purchaseModalHeight () {
    return this.data.get('purchaseModalHeight');
  }

  get row () {
    return this.data.get('row');
  }

  get priority () {
    return this.data.get('priority');
  }

  get status () {
    return this.data.get('status');
  }

  get body () {
    return this.data.get('body');
  }

  get disable () {
    return this.data.get('disable');
  }

  get showMoreInfoButton () {
    return this.data.get('showMoreInfoButton');
  }

  get showStatusBar () {
    return this.data.get('showStatusBar');
  }

  get preorder () {
    return this.data.get('preorder');
  }

  get ratingsBoards () {
    return this.data.get('ratingsBoards', {});
  }

  get skuGroups () {
    return this.data.get('skuGroups', []);
  }

  get hasRestrictions () {
    return this.data.get('hasRestrictions', false);
  }

  get footnote () {
    return this.data.get('footnote', '');
  }

  get adminLabel () {
    return this.title && this.title.length > 0 ? `${this.title}${(this.subtitle) ? `: ${this.subtitle}` : ''}` :  '<new shop item>';
  }

  get linkedContentPaths () {
    let ratingsBoardsPaths = Object.values(this.ratingsBoards.toJS()).map(imageLinks => (
      imageLinks.map(img => (img.imagePath))
    )).reduce((a, b) => (a.concat(b)));

    return [this.backgroundPath, this.modalBackgroundPath].concat(ratingsBoardsPaths);
  }


}

// ShopItem.translatedAttributes = {
//   body:{

//   },
//   title: {

//   },
//   subtitle?
//   modalTitle?
// }

/*
,
     "ShopIndexer",
     "ShopItem",
     "ShopItemBySlug"
 */



// WEBPACK FOOTER //
// ./lib/rlink-shop/index.js